import { IContentSource } from "../../../base/domain/drawing";
export class ReferenceFileContentSource {
  constructor(public id: number, public source: IContentSource) {
  }
}
